module.exports = __webpack_public_path__ + "0924f2e24d334b07d96a768febbe2984.png";